module.exports = {"confirmDeleteOrder":"ยืนยันลบรายการ","fillInreason":"ระบุเหตุผล"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/modal/TH.json
// module id = 1354
// module chunks = 121